import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Google(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M12 4a8 8 0 108 8h-6v1h3.125a1 1 0 01.931 1.364A6.502 6.502 0 015.5 12a6.5 6.5 0 019.257-5.888l.978-1.188A7.961 7.961 0 0012 4zM2 12C2 6.477 6.477 2 12 2c2.168 0 4.177.69 5.816 1.864a1 1 0 01.19 1.45l-2.234 2.711a1 1 0 01-1.318.202 4.5 4.5 0 10.9 6.773H13a1 1 0 01-1-1v-3a1 1 0 011-1h8a1 1 0 011 1v1c0 5.523-4.477 10-10 10S2 17.523 2 12z",
    clipRule: "evenodd"
  }));
}

export default Google;